import React from 'react';
import Sidebar from '../Sidebar'; 
import MainMenu from '../MainMenu'; 
import DailyReportListMain from './DailyReportListMain';
import './css/DailyReport.css'

function DailyReportList() {
  return (
      <>
          <MainMenu />
          <div className="main-container">
              <Sidebar selectedIcon="daily-report" />
              <DailyReportListMain />
          </div>      
      </>
  );
}

export default DailyReportList;